import { useTypedParams } from '@sorare/core/src/lib/routing';

import { ProfileLayoutArena } from 'components/rivals/ProfileLayout/ProfileLayoutArena';

import { PageParams } from './__generated__/routeParams';

const RivalriesArenaPage = () => {
  const { selectedUserSlug } = useTypedParams<PageParams>();
  return <ProfileLayoutArena selectedUserSlug={selectedUserSlug} />;
};
export default RivalriesArenaPage;
